// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2G1iv","alertIcon":"ConfirmModal_alertIcon__3m2Sc"};